import React from "react";

import { Tag } from "antd";

import { Icon } from "components";

interface TagNormalProps {
  dataTestId?: string;
  className?: string;
  icon?: string;
  color?: string;
  type?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
  text: string;
}

export const TagNormal = ({ dataTestId = "", icon, color = "", type = "", style, onClick = () => {}, text, className = "" }: TagNormalProps) => {
  const getIcon = () => {
    if (icon) {
      return <Icon iconName={icon} className="icon inline filled" />;
    }
    return <></>;
  };

  return (
    <Tag className={`${className} ${color} ${type}`} style={style} onClick={onClick} data-testid={dataTestId}>
      {getIcon()}
      <span className="paragraph-xs-bold">{text}</span>
    </Tag>
  );
};
